import React from "react";
import { createHashRouter } from "react-router-dom";
import Home from "../views/Home";
import Sobre from "../views/Sobre";
import Servicos from "../views/Servicos";
import Solucoes from "../views/Solucoes";
import Equipe from "../views/Equipe";
import Cursos from "../views/Cursos";
import Portfolio from "../views/Portfolio";
import Blog from "../views/Blog";
import Contato from "../views/Contato";
import Orcamento from "../views/Orcamento";
import Empresas from "../views/Empresas";
import Agencia from "../views/Agencia";
import Portal from "../views/Portal";
import Loja from "../views/Loja";
import Catalogo from "../views/Catalogo";
import Termos from "../views/Termos";
import Privacidade from "../views/Privacidade";
import Cookies from "../views/Cookies";
import NoticiaDetalhes from "../views/DetailsBlog";

const router = createHashRouter([
  { path: "/", element: <Home /> },
  { path: "/sobre", element: <Sobre /> },
  { path: "/servicos", element: <Servicos /> },
  { path: "/solucoes", element: <Solucoes /> },
  { path: "/equipe", element: <Equipe /> },
  { path: "/cursos", element: <Cursos /> },
  { path: "/portfolio", element: <Portfolio /> },
  { path: "/blog", element: <Blog /> },
  { path: "/noticias/:id/", element: <NoticiaDetalhes /> },
  { path: "/contato", element: <Contato /> },
  { path: "/orcamento", element: <Orcamento /> },
  { path: "/empresas", element: <Empresas /> },
  { path: "/agencia", element: <Agencia /> },
  { path: "/portal", element: <Portal /> },
  { path: "/loja", element: <Loja /> },
  { path: "/catalogo", element: <Catalogo /> },
  { path: "/termos", element: <Termos /> },
  { path: "/privacidade", element: <Privacidade /> },
  { path: "/cookies", element: <Cookies /> },
  { path: "*", element: <Home /> },
]);

export default router;
